// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__yPtlw","productName":"Table_productName__1gh-B"};